var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.rowStart < _vm.lastLine && _vm.rowEnd > 1 && _vm.rowStart < _vm.rowEnd ? _c('div', {
    staticClass: "event-flow-item",
    class: {
      extended: _vm.extraFunctionFormData.showTime || _vm.extraFunctionFormData.showBrief
    },
    style: {
      'grid-column': _vm.index + 1,
      'grid-row-start': _vm.rowStart,
      'grid-row-end': _vm.rowEnd,
      'background-color': _vm.eventFlowItem.responsible && _vm.eventFlowItem.responsible.color
    },
    on: {
      "click": function ($event) {
        return _vm.click(_vm.eventFlowItem);
      }
    }
  }, [_c('div', {
    staticClass: "brief-top",
    class: {
      'brief-bottom': _vm.isNearTop,
      'brief-top-inside': _vm.isNearTop && _vm.isNearBottom,
      'extended': _vm.extraFunctionFormData.showTime || _vm.extraFunctionFormData.showBrief
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.extraFunctionFormData.showTime,
      expression: "extraFunctionFormData.showTime"
    }]
  }, [_c('strong', [_vm._v(" " + _vm._s(_vm.eventFlowItem.startedAt.toLocaleTimeString(this.$i18n.locale, _vm.timeFormatOptions)) + " "), _c('div', {
    staticClass: "divider"
  }, [_vm._v("-")]), _vm._v(" " + _vm._s(_vm.eventFlowItem.endedAt.toLocaleTimeString(this.$i18n.locale, _vm.timeFormatOptions)) + " ")])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.extraFunctionFormData.showBrief,
      expression: "extraFunctionFormData.showBrief"
    }]
  }, [_vm._v(" " + _vm._s(_vm.eventFlowItem.brief) + " ")])]), !_vm.isSheet && _vm.canMoveTop(_vm.eventFlowItem) ? _c('div', {
    staticClass: "resize resize-top",
    on: {
      "pointerdown": function ($event) {
        return _vm.onResizePointerDown($event, 'start');
      }
    }
  }) : _vm._e(), !_vm.isSheet ? _c('div', {
    staticClass: "drag",
    attrs: {
      "draggable": ""
    },
    on: {
      "drag": function ($event) {
        if ($event.target !== $event.currentTarget) return null;
        return _vm.throttleMoveItem($event, _vm.eventFlowItem);
      },
      "dragstart": function ($event) {
        return _vm.onDragStartMovement($event, _vm.eventFlowItem);
      },
      "dragend": function ($event) {
        return _vm.onDragEndMovement(_vm.eventFlowItem);
      }
    }
  }) : _vm._e(), !_vm.isSheet && _vm.canMoveBottom(_vm.eventFlowItem) ? _c('div', {
    staticClass: "resize resize-bottom",
    on: {
      "pointerdown": function ($event) {
        return _vm.onResizePointerDown($event, 'end');
      }
    }
  }) : _vm._e()]) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }